module.exports = __webpack_public_path__ + "img/cover-minigame-bg-mobile.5d4e0838.jpg";